// extracted by mini-css-extract-plugin
export default {"wrap":"section__wrap__TY","colors":"section__colors__nF","size":"section__size__Tr"};